import { render, staticRenderFns } from "./menu-item-product.vue?vue&type=template&id=d0d1df6a&scoped=true&"
import script from "./menu-item-product.vue?vue&type=script&lang=js&"
export * from "./menu-item-product.vue?vue&type=script&lang=js&"
import style0 from "./menu-item-product.vue?vue&type=style&index=0&id=d0d1df6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d1df6a",
  null
  
)

export default component.exports